import React from "react"

export const QuotationmarkIcon = ({ size = 1, color = "#034B64" }) => {
  return (
    <svg
      width={size * 84}
      height={size * 45}
      viewBox="0 0 84 45"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.1">
        <path
          fill={color}
          d="M0,44.8L17.7,0.2h26.4L26,44.8H0z M39.9,44.8L57.6,0.2H84L65.9,44.8H39.9z"
        />
      </g>
    </svg>
  )
}
